import { forAllHil } from '../channels';
import { Joi, actionCreator, objectSchemaOf } from '../helpers';
import { JOBS_OUTPUT } from './topics';

export const AVAILABLE = 'JOBS/AVAILABLE' as const;

export const availableActionSchema = objectSchemaOf<IAvailableAction>({
  type: Joi.string().required().valid(AVAILABLE),
  payload: objectSchemaOf<IAvailablePayload>({
    available: Joi.boolean().required(),
    interventionRequired: Joi.boolean().required(),
    timestamp: Joi.number().required(),
  }).required(),
});

export interface IAvailablePayload {
  available: boolean;
  interventionRequired: boolean;
  timestamp: number;
}

export interface IAvailableAction {
  type: typeof AVAILABLE;
  payload: IAvailablePayload;
}

export const available = actionCreator({
  schema: availableActionSchema,
  topic: JOBS_OUTPUT,
  type: AVAILABLE,
  channels: [forAllHil],
});
